///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import { globalLoadingActionCreators, errorManagerActionCreators, accountActionCreators, toastSuccessActionCreators } from '../actions'
import * as R from '../../constants/Endpoint'
import { API_TOKEN } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'

const getAccount = function* () {
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_ACCOUNT()
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)
		yield put(accountActionCreators.getAccountSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(accountActionCreators.getAccountFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const updateAccount = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.UPDATE_ACCOUNT()
	const inputUser = {
		idPreferedLanguage: payload.myAccount.idPreferedLanguage,
		firstName: payload.myAccount.firstName,
		lastName: payload.myAccount.lastName,
		email: payload.myAccount.email,
		//"phoneNumber" : payload.myAccount.phoneNumber,
		oldPassword: payload.myAccount.oldPassword,
		newPassword: payload.myAccount.newPassword,
	}

	// Phone number is submit only if we have digits
	if (payload.myAccount.phoneNumber.length > 0) inputUser.phoneNumber = payload.myAccount.phoneNumber

	const MsgParams = 'toast__myAccount__updateAccount'
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall, inputUser)

		yield put(accountActionCreators.updateAccountSuccess(data.data))

		yield put(toastSuccessActionCreators.hydrateToast(MsgParams))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(accountActionCreators.updateAccountFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.GET_ACCOUNT, getAccount)
	yield takeLatest(ActionsTypes.UPDATE_MY_ACCOUNT, updateAccount)
}

export default sagas
